var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwesomeArrowAltCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.808,
    height: 44.81,
    viewBox: "0 0 44.808 44.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#34366d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.966.563a22.4,22.4,0,1,0,22.4,22.405A22.4,22.4,0,0,0,22.966.563Zm10.479,26.38H22.966v6.405a1.085,1.085,0,0,1-1.852.768L10.789,23.735a1.074,1.074,0,0,1,0-1.527L21.114,11.819a1.084,1.084,0,0,1,1.852.768v6.405H33.446a1.087,1.087,0,0,1,1.084,1.084v5.782A1.087,1.087,0,0,1,33.446,26.943Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeArrowAltCircleRight);
export default __webpack_public_path__ + "static/media/Icon_awesome_arrow_alt_circle_right.2bacf1ee56ea1d9c0f9ff096df3123c4.svg";
export { ForwardRef as ReactComponent };